import { render } from "./messageUserWise.vue?vue&type=template&id=b08084c8"
import script from "./messageUserWise.vue?vue&type=script&lang=js"
export * from "./messageUserWise.vue?vue&type=script&lang=js"

import "./messageUserWise.vue?vue&type=style&index=0&id=b08084c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__